import React, { useState } from 'react';
import {Form, Input, Textarea, Button} from "@heroui/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "@heroui/modal";

const OrgForm = ({user, dismissModal, setBanner, org, switchOrg, setUser}) => {
  const [orgName, setOrgName] = useState(org?.name);
  const [orgDescr, setOrgDescr] = useState(org?.description);
  const [copyrightText, setCopyrightText] = useState(org?.copyright_text || '');
  const [error, setError] = useState();
  const minNameLength = 3;

  // Check if user can edit copyright (admin or org owner/coadmin)
  const canEditCopyright = user?.admin || (org && user?.active_organization?.member?.role && ['admin', 'coadmin'].includes(user.active_organization.member.role));

  const createOrg = async () => {
    if (!orgName) {
      setError('Organization name is required.');
      return;
    } else if (orgName && orgName.length < minNameLength) {
      setError('Organization name is too short!');
      return;
    }
    let fd = new FormData();
    fd.append('name', orgName);
    if (orgDescr && orgDescr !== '') {
      fd.append('description', orgDescr);
    } else {
      fd.append('description', '');
    }
    if (canEditCopyright && copyrightText !== undefined) {
      fd.append('copyright_text', copyrightText);
    }
    const d = await fetch(`/api/v1/organizations${org ? '/' + org._id : ''}`, {method: org ? 'PUT' : 'POST', body: fd});
    const orgJson = await d.json();
    if (d.status === 200) {
      setBanner(`Org ${orgName} ${org ? 'updated' : 'created'}`);
      dismissModal();
      if (!org) {
        setUser(orgJson['user']);
        switchOrg(orgJson['organization']['_id']);
      }
    } else {
      setError(`Error ${org ? 'updating' : 'creating'} organization: ${d.status}`);
    }
  }

  return (
    <Form onSubmit={createOrg}>
      <Modal placement='top' isOpen={true} isDismissable={true} isKeyboardDismissDisabled={true} onClose={dismissModal}>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>
            Create Organization
          </ModalHeader>
          <ModalBody>
            { error && <span style={{fontSize: '14px', color: '#ff0000'}}>{error}</span> }
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <div style={{marginBottom: '10px'}}>
                <Input isRequired label='Org Name' onChange={(d) => setOrgName(d.target.value)} minLength={minNameLength} maxLength='50' value={orgName} />
              </div>
              <div style={{marginBottom: '10px'}}>
                <Textarea label='Description' onChange={(d) => setOrgDescr(d.target.value)} value={orgDescr} />
              </div>
              {canEditCopyright && (
                <div style={{marginBottom: '10px'}}>
                  <Input
                    label='Copyright Text (optional)'
                    placeholder='Pens for Swords, All Rights Reserved'
                    onChange={(d) => setCopyrightText(d.target.value)}
                    value={copyrightText}
                    startContent={
                      <div style={{
                        fontSize: '14px',
                        color: '#666',
                        whiteSpace: 'nowrap',
                        paddingRight: '4px'
                      }}>
                        © {new Date().getFullYear()}
                      </div>
                    }
                    classNames={{
                      inputWrapper: 'border-orange-500 border-2'
                    }}
                  />
                  <div style={{fontSize: '12px', color: '#888', marginTop: '4px'}}>
                    This will be appended to all campaign emails from this organization
                  </div>
                </div>
              )}
              <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '394px'}}>
                <Button style={{marginTop: '10px'}} onPress={() => dismissModal()}>Cancel</Button>
                <Button style={{margin: '10px'}} onPress={() => createOrg()} color='success'>{org ? 'Update' : 'Create'}</Button>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Form>
  );
}

export default OrgForm;
